import { HTMLProps } from 'react';

import { makeStyles } from '@material-ui/core';

import classNames from 'classnames';
import { diffJson } from 'diff';

const useStyles = makeStyles({
  root: {
    fontFamily: 'var(--encore-bodyMono-font-stack, monospace)',
    fontSize: 'var(--encore-text-size-smaller-2)',
    whiteSpace: 'pre',
  },
  line: {
    // So that background colors are applied correctly to the entire line
    display: 'table',
  },
  added: {
    background:
      'color-mix(in srgb, var(--background-positive-subdued-base) 80%, transparent)',
    color: 'var(--essential-positive)',
  },
  removed: {
    background:
      'color-mix(in srgb, var(--background-negative-subdued-base) 80%, transparent)',
    color: 'var(--essential-negative)',
  },
});

export interface JsonDiffProps extends HTMLProps<HTMLDivElement> {
  oldValue?: object | undefined;
  newValue?: object | undefined;
}

export const JsonDiff = ({
  oldValue,
  newValue,
  className,
  ...rest
}: JsonDiffProps) => {
  const classes = useStyles();

  const diff = diffJson(oldValue ?? '', newValue ?? '');

  return (
    <div className={classNames(classes.root, className)} {...rest}>
      {diff.map((line, index) => (
        <div
          key={index}
          className={classNames(classes.line, {
            [classes.added]: line.added,
            [classes.removed]: line.removed,
          })}
        >
          {line.value}
        </div>
      ))}
    </div>
  );
};
